import { Service } from '@roc/feature-app-core';

const url = {
  GET_FORM_INFO:
    '/api/v1/loan/public/borrowerIdentityCheck/getBorrowerIdentityCheckFormInfo',
  UPLOAD_DRIVERS_LICENSE:
    '/api/v1/loan/public/borrowerIdentityCheck/uploadDriversLicense',
  SAVE_FINANCIAL_INFORMATION:
    '/api/v1/loan/public/borrowerIdentityCheck/saveFinancialInformation',
};

export class IdentityCheckPublicService extends Service {
  getFormInfo(token: string) {
    return this.get(url.GET_FORM_INFO, { token });
  }

  uploadDriversLicense(token: string, identityCheckForm, driversLicense: File) {
    const identityCheckJson = new Blob([JSON.stringify(identityCheckForm)], {
      type: 'application/json',
    });

    const formData = new FormData();
    formData.append('token', token);
    formData.append('identityCheckForm', identityCheckJson);
    formData.append('driversLicense', driversLicense);

    return this.post(url.UPLOAD_DRIVERS_LICENSE, formData);
  }

  saveFinancialInformation(token: string, data) {
    return this.post(url.SAVE_FINANCIAL_INFORMATION, { ...data, token });
  }

}
